import { Attribute, component, property } from '../../../concepts/objects';
import { Physical } from '../../canvas/entities/Physical';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Resizable } from '../../canvas/entities/Resizable';
import { Snappable } from '../../canvas/entities/Snappable';
import { SmartBoxPropertyLayout } from './SmartBoxPropertyLayout';

// const mutation = defineCommand(
//     'formulaBoxMutate',
//     'SmartBox: Mutate',
//     (cc, [id]: [string]) => {
//         r.call(EditorSession).update(AdapterInfo, CreateAdapterInfo(id, 'field'));
//     },
//     [],
// );

const smartBoxDef = {
    name: 'SmartBox',
    implements: [Physical, Resizable, Snappable],
    propertyLayout: SmartBoxPropertyLayout,
};

export const SmartBoxComputation = new Attribute<number | string, SmartBox>('computation');

@component(smartBoxDef)
export class SmartBox extends RectangularPhysical implements Physical, Snappable {

    @property({ type: 'string', default: null, style: true })
    public background!: string;

    @property({ type: 'number', default: 6, style: true })
    public cornerRadius!: number;

    public get boundary() {
        return true;
    }

    public get shouldSnap() {
        return true;
    }

    public toHumanString(): string {
        const value = SmartBoxComputation.get(this) || '';
        return `SmartBox ("${this.name || value}")`;
    }
}
